import Persona from 'persona';
import { useState } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import jwt_decode from 'jwt-decode';
import { backendRoutes, frontendRoutes } from '../../../Constants/constants';
import { getUserInfo, setInquiryId } from '../../../redux/action/action';
import { BuilderSettings } from '../../../redux/types/builders';
import { usePostAuthRedirect } from '../../../hooks/usePostAuthRedirect';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';
import { SurveyNavigationState } from '../../../types/navigation';

interface TokenPayload {
  customerId: number;
  username: string;
  iat: number;
  exp: number;
}

const TextVerify = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [catchUpError, setCatchUpError] = useState('');

  const dispatch = useDispatch();
  let params = useParams<{ builder_name?: string }>();
  const history = useHistory();
  const navigationState = history.location.state as SurveyNavigationState | undefined;
  const builderSettings: BuilderSettings = useSelector((state: any) => state.builder.settings);
  const builder_id: number = useSelector((state: any) => state.builder.builder_id)
  const phoneNumber = useSelector((state: any) => state.phNumber.phNumber?.phone);
  const propertyId = useSelector((state: any) => state.property.property?.id);
  const isSelfieVerificationActive = builderSettings.selfie_verification_active;
  const isHighSecurityVerificationActive = builderSettings.high_security_verification_active;

  const redirectAfterAuth = usePostAuthRedirect();

  let templateId = isSelfieVerificationActive
    ? process.env.REACT_APP_PERSONA_SELFIE_TEMPLATE_ID
    : process.env.REACT_APP_PERSONA_TEMPLATE_ID;

  if (isHighSecurityVerificationActive) {
    templateId = process.env.REACT_APP_PERSONA_HIGH_SECURITY_TEMPLATE_ID;
  }

  const inquiryFields = {
    "property_id": propertyId,
    "email_address": '',
    "phone_number": phoneNumber,
    "builder_id": builder_id || 0,
    "builder": params.builder_name || '',
  }
  
  return (
    <section className="main-section d-flex justify-content-center">
      <div className="box">
        <div className={`box-data d-flex flex-column ${isLoading && 'visually-hidden'}`}>
          <Persona.Inquiry
            templateId={templateId}
            referenceId={phoneNumber}
            environment={process.env.REACT_APP_PERSONA_ENV || 'production'}
            fields={inquiryFields}
            onReady={() => {
              setIsLoading(false);
            }}
            onLoad={() => {}}
            onComplete={async ({ inquiryId, status, fields }) => {
              if (status === 'failed') {
                history.push(frontendRoutes.phoneVerify(params.builder_name).path, navigationState);
                return;
              }

              if (navigationState?.catchUp) {
                setCatchUpError('');
                setIsLoading(true);
                try {
                  await axios({
                    baseURL: backendRoutes.MOBILE_BASE_URL,
                    url: backendRoutes.complete_verification,
                    method: 'POST',
                    headers: { 'x-auth-token': localStorage.getItem('user_token') },
                    data: { inquiryId },
                  });
                  const storedToken = localStorage.getItem('user_token');
                  if (storedToken) {
                    const customer: TokenPayload = jwt_decode(storedToken);
                    dispatch(getUserInfo(customer.customerId));
                    await redirectAfterAuth(customer.customerId);
                  }
                } catch (err: any) {
                  setIsLoading(false);
                  if (err?.response?.status === 422) {
                    setCatchUpError('Identity verification could not be confirmed. Please try again.');
                  } else {
                    setCatchUpError('Something went wrong. Please try again.');
                  }
                }
                return;
              }

              localStorage.setItem('fields', JSON.stringify(fields));

              dispatch(setInquiryId(inquiryId));
              history.push(frontendRoutes.isThisYou(params.builder_name).path, navigationState);
            }}
          />
          {catchUpError && (
            <span className="invalid-feedback d-block" style={{ marginTop: '8px' }}>
              {catchUpError}
            </span>
          )}
        </div>
        {isLoading && <LoadingSpinner />}
      </div>
    </section>
  );
};

export default TextVerify;
